// Cuffing someone (Grey, 2026-10-16): with the handcuffs in your hand, hold the left button (RT on a pad) on whoever is within
// reach for two seconds; or pick Cuff in the F menu and stay beside them. The ship starts the clock (so the two seconds are
// real), the bar fills under the crosshair as a revive's does, and stepping out of reach (or, from the menu, moving at all)
// stops it. The rules are shared/cuffs.ts; the server does the cuffing.
import { CUFF_SECONDS, alongTrail, linePlace, trailPush, type P3 } from "../shared/cuffs.js";

// your place in the line when you're walked (a step behind whoever leads you) or helping walk someone (a step behind them), along
// the way the leader went: the leader's path is kept here, from where this browser sees them (shared/cuffs.ts)
export class EscortLine {
  private trail: P3[] = []; private lead: string | null = null; private dist = 0;
  get leader() { return this.lead; }
  // start (or stop) following: the line begins from where you stand, so nobody is pulled through the leader to get behind them
  set(lead: string | null, role: "prisoner" | "helper", me: P3 | null, leadAt: P3 | null) {
    this.lead = lead; this.dist = linePlace(role); this.trail = lead && me && leadAt ? [{ ...leadAt }, { ...me }] : [];
  }
  place(leadAt: P3, leadYaw: number): { pos: P3; yaw: number } { this.trail = trailPush(this.trail, leadAt); return alongTrail(this.trail, this.dist, leadYaw); }
}

export interface CuffDeps {
  send(m: Record<string, unknown>): void;
  notice(text: string): void;
  near(id: string): boolean;          // still within reach to cuff
  moving(): boolean;                  // walking (a menu's cuffing stops when you move, as a revive does)
  bar(): HTMLElement;                 // the hold bar (the revive's)
}
export class CuffHold {
  private asked: { id: string; name: string; free: boolean; at: number } | null = null;
  private hold: { id: string; name: string; free: boolean; start: number; until: number } | null = null;
  private pressed = false;
  constructor(private deps: CuffDeps) {}
  get busy() { return !!this.asked || !!this.hold; }
  // begin: held (the button, which must stay down) or free (from the F menu: stay beside them)
  start(id: string, name: string, free: boolean) {
    if (this.busy) return; this.pressed = !free;
    this.asked = { id, name, free, at: performance.now() }; this.deps.send({ t: "cuff", to: id, start: true });
  }
  // the ship's go-ahead: the clock runs
  onCuffing(id: string, seconds = CUFF_SECONDS) {
    const a = this.asked; if (!a || a.id !== id) return; this.asked = null;
    if (!a.free && !this.pressed) return;                             // let go before the answer came
    const t = performance.now(); this.hold = { id: a.id, name: a.name, free: a.free, start: t, until: t + seconds * 1000 };
  }
  // the button let go
  release() { this.pressed = false; if (this.hold && !this.hold.free) this.cancel("You let go."); else if (this.asked && !this.asked.free) this.asked = null; }
  cancel(why?: string) { if (this.hold) this.deps.bar().classList.add("hidden"); const was = this.busy; this.hold = null; this.asked = null; if (why && was) this.deps.notice(why); }
  tick() {
    if (this.asked && performance.now() - this.asked.at > 2500) this.asked = null;   // the ship said no (its notice says why)
    const h = this.hold; if (!h) return;
    if (!this.deps.near(h.id)) { this.cancel(`${h.name} is out of reach.`); return; }
    if (h.free && this.deps.moving()) { this.cancel("You stopped."); return; }
    const left = h.until - performance.now(), el = this.deps.bar(); el.classList.remove("hidden");
    (el.firstElementChild as HTMLElement).style.width = `${Math.max(0, Math.min(100, 100 - (left / (h.until - h.start)) * 100))}%`;
    el.lastElementChild!.textContent = `Cuffing ${h.name} · ${Math.max(0, left / 1000).toFixed(1)} s · ${h.free ? "stay beside them (moving stops it)" : "keep the button held"}`;
    if (left <= 0) { const id = h.id; this.hold = null; el.classList.add("hidden"); this.deps.send({ t: "cuff", to: id }); }
  }
}
